"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const gamingStationsTabsListBlocks = Array.from(document.querySelectorAll('section.gaming-stations-tabs-list'));
    gamingStationsTabsListBlocks.forEach(gamingStationsTabsBlock => {
        const gsContainerEl = gamingStationsTabsBlock.querySelector('.gs-container');
        let previousHeight = gsContainerEl?.clientHeight ?? 0;
        let resetTimeout = null;
        // Sets the height of the gs-container to the height of its contents
        function setGsContainerHeight() {
            if (!gsContainerEl) {
                return;
            }
            const newHeight = gsContainerEl.scrollHeight;
            gsContainerEl.style.height = `${previousHeight}px`;
            console.log('setting height to', previousHeight);
            requestAnimationFrame(() => {
                gsContainerEl.style.height = `${newHeight}px`;
                console.log('setting height to', newHeight);
                previousHeight = newHeight;
            });
            if (resetTimeout) {
                clearTimeout(resetTimeout);
            }
            resetTimeout = setTimeout(() => {
                gsContainerEl.style.height = '';
            }, 500);
        }
        // Add "tabChanged" listener on tab control to play the new active video and stop the previous one
        const tabsControl = gamingStationsTabsBlock.querySelector('.tab-controls-container');
        tabsControl?.addEventListener('tabChanged', () => {
            console.log('tabChanged');
            setGsContainerHeight();
        });
    });
});
